import gql from "graphql-tag";

//Get states
export const GET_STATES = gql`
    query {
        getStates{
            name
            abbreviation
            country
            type
        }
    }
`;